/* Vokshus produktønsker (Elias GO 15/10 2026, work/Önskemål/Design.md). Vanilla IIFE, inga beroenden.
   Tumme, eget önskemål och «gi meg beskjed» → Klaviyos klient-API med den publika nyckeln (aldrig den privata).
   En tumme per kort och webbläsare (localStorage, alltid i try/catch). Fel → meddelande, knappen kan tryckas igen.
   Utanför LIVE-temat märks varje händelse test: true, och rapporten räknar dem aldrig. */
(function () {
  'use strict';
  var API = 'https://a.klaviyo.com/client/';
  var REVISION = '2026-07-15';
  var MAX = 200;
  var NYCKEL_ID = 'vk_onske_id';
  var NYCKEL_STEMT = 'vk_onske_stemt';

  function rensTekst(t) {
    return String(t == null ? '' : t).replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, MAX);
  }

  function giltigEpost(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(e == null ? '' : e).replace(/^\s+|\s+$/g, ''));
  }

  function nyttId() {
    var s = '', i;
    for (i = 0; i < 4; i++) s += Math.floor((1 + Math.random()) * 0x10000).toString(16).slice(1);
    return 'vk-' + s + '-' + new Date().getTime().toString(36);
  }

  function byggHandelse(metrik, egenskaper, anonymId) {
    return {data: {type: 'event', attributes: {
      properties: egenskaper,
      metric: {data: {type: 'metric', attributes: {name: metrik}}},
      profile: {data: {type: 'profile', attributes: {anonymous_id: anonymId}}}
    }}};
  }

  function byggStemme(produkt, sprak, side, anonymId, test) {
    var p = {produkt: produkt, sprak: sprak, side: side};
    if (test) p.test = true;
    return byggHandelse('Produktønske stemme', p, anonymId);
  }

  function byggOnske(tekst, sprak, side, anonymId, test) {
    var p = {tekst: rensTekst(tekst), sprak: sprak, side: side};
    if (test) p.test = true;
    return byggHandelse('Produktønske tekst', p, anonymId);
  }

  function byggAbonnement(epost, lista, produkt, sprak) {
    return {data: {type: 'subscription', attributes: {
      custom_source: 'Produktønsker vokshus.com',
      profile: {data: {type: 'profile',
        attributes: {email: String(epost).replace(/^\s+|\s+$/g, ''), properties: {onske_sprak: sprak},
          subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}},
        meta: {patch_properties: {append: {onsket_produkt: produkt}}}}}
    }, relationships: {list: {data: {type: 'list', id: lista}}}}};
  }

  function skicka(url, kropp, klar) {
    var gjort = false, json = JSON.stringify(kropp), x;
    function en(ok) { if (!gjort) { gjort = true; klar(ok); } }
    window.setTimeout(function () { en(false); }, 10000);
    try {
      if (window.fetch) {
        window.fetch(url, {method: 'POST', headers: {'Content-Type': 'application/vnd.api+json', revision: REVISION}, body: json})
          .then(function (r) { en(r.status >= 200 && r.status < 300); }, function () { en(false); });
        return;
      }
      x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/vnd.api+json');
      x.setRequestHeader('revision', REVISION);
      x.onload = function () { en(x.status >= 200 && x.status < 300); };
      x.onerror = function () { en(false); };
      x.send(json);
    } catch (e) { en(false); }
  }

  function lagring() {
    try { var s = window.localStorage; s.setItem('vk_onske_prov', '1'); s.removeItem('vk_onske_prov'); return s; } catch (e) { return null; }
  }

  function hentId(s) {
    var id = null;
    if (s) { try { id = s.getItem(NYCKEL_ID); } catch (e) { id = null; } }
    if (!id) {
      id = nyttId();
      if (s) { try { s.setItem(NYCKEL_ID, id); } catch (e) { /* privat läge: nytt id nästa gång */ } }
    }
    return id;
  }

  function stemte(s) {
    if (!s) return {};
    try { return JSON.parse(s.getItem(NYCKEL_STEMT) || '{}') || {}; } catch (e) { return {}; }
  }

  function merkStemt(s, produkt) {
    var m;
    if (!s) return;
    m = stemte(s);
    m[produkt] = 1;
    try { s.setItem(NYCKEL_STEMT, JSON.stringify(m)); } catch (e) { /* privat läge */ }
  }

  function url(cfg, typ) {
    return API + typ + '/?company_id=' + encodeURIComponent(cfg.nokkel);
  }

  function visEpost(skjema, cfg, produkt) {
    var felt, status, knapp;
    if (!skjema || !cfg.lista || skjema.getAttribute('data-vk-koblet')) return;
    skjema.setAttribute('data-vk-koblet', '1');
    felt = skjema.querySelector('input[type="email"]');
    status = skjema.querySelector('[data-vk-onske-status]');
    knapp = skjema.querySelector('button');
    skjema.hidden = false;
    skjema.addEventListener('submit', function (e) {
      e.preventDefault();
      if (knapp.disabled) return;
      if (!giltigEpost(felt.value)) { status.textContent = cfg.t('ugyldig'); felt.focus(); return; }
      knapp.disabled = true;
      status.textContent = '';
      skicka(url(cfg, 'subscriptions'), byggAbonnement(felt.value, cfg.lista, produkt, cfg.sprak), function (ok) {
        knapp.disabled = false;
        if (!ok) { status.textContent = cfg.t('feil'); return; }
        felt.value = '';
        skjema.querySelector('[data-vk-onske-felt]').hidden = true;
        status.textContent = cfg.t('epost-takk');
      });
    });
  }

  function kobleKort(kort, cfg, s, id, har) {
    var produkt = kort.getAttribute('data-vk-onske-kort');
    var knapp = kort.querySelector('[data-vk-onske-stem]');
    var melding = kort.querySelector('[data-vk-onske-melding]');
    var skjema = kort.querySelector('[data-vk-onske-epost]');
    if (!produkt || !knapp || !melding) return;
    if (har[produkt]) { melding.textContent = cfg.t('takk'); return; }
    knapp.hidden = false;
    knapp.addEventListener('click', function () {
      if (knapp.disabled) return;
      knapp.disabled = true;
      melding.textContent = '';
      skicka(url(cfg, 'events'), byggStemme(produkt, cfg.sprak, window.location.pathname, id, cfg.test), function (ok) {
        knapp.disabled = false;
        if (!ok) { melding.textContent = cfg.t('feil'); return; }
        merkStemt(s, produkt);
        knapp.hidden = true;
        melding.textContent = cfg.t('takk');
        visEpost(skjema, cfg, produkt);
      });
    });
  }

  function kobleFritt(fritt, rot, cfg, id) {
    var felt = fritt.querySelector('textarea');
    var melding = fritt.querySelector('[data-vk-onske-melding]');
    var knapp = fritt.querySelector('button');
    var etter = rot.querySelector('[data-vk-onske-fritt-epost] [data-vk-onske-epost]');
    if (!felt || !melding || !knapp) return;
    fritt.hidden = false;
    fritt.addEventListener('submit', function (e) {
      var tekst = rensTekst(felt.value);
      e.preventDefault();
      if (knapp.disabled) return;
      if (tekst.length < 2) { melding.textContent = cfg.t('tom'); felt.focus(); return; }
      knapp.disabled = true;
      melding.textContent = '';
      skicka(url(cfg, 'events'), byggOnske(tekst, cfg.sprak, window.location.pathname, id, cfg.test), function (ok) {
        knapp.disabled = false;
        if (!ok) { melding.textContent = cfg.t('feil'); return; }
        felt.value = '';
        fritt.querySelector('[data-vk-onske-felt]').hidden = true;
        melding.textContent = cfg.t('onske-takk');
        visEpost(etter, cfg, 'eget-onske');
      });
    });
  }

  function koble(rot) {
    var s, id, har, kort, i, fritt;
    var tema = window.Shopify && window.Shopify.theme;
    var cfg = {
      nokkel: rot.getAttribute('data-klaviyo'),
      lista: rot.getAttribute('data-lista'),
      sprak: rot.getAttribute('data-sprak') || 'nb',
      test: !(tema && tema.role === 'main'),
      t: function (k) { return rot.getAttribute('data-t-' + k) || ''; }
    };
    if (!cfg.nokkel) return;
    s = lagring();
    id = hentId(s);
    har = stemte(s);
    kort = rot.querySelectorAll('[data-vk-onske-kort]');
    for (i = 0; i < kort.length; i++) kobleKort(kort[i], cfg, s, id, har);
    fritt = rot.querySelector('[data-vk-onske-fritt]');
    if (fritt) kobleFritt(fritt, rot, cfg, id);
  }

  function start() {
    var rotter = document.querySelectorAll('[data-vk-onske]'), i;
    for (i = 0; i < rotter.length; i++) koble(rotter[i]);
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = {rensTekst: rensTekst, giltigEpost: giltigEpost, nyttId: nyttId,
      byggStemme: byggStemme, byggOnske: byggOnske, byggAbonnement: byggAbonnement};
    return;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
